<template>
  <div id="function-management" class="h-full">
    <el-card class="h-full !pt-0">
      <!-- input输入框部分 -->
      <div class="head mb-20px mx-10px">
        <el-input
          v-model="functionName"
          class="mr-10px"
          placeholder="功能名称"
          clearable
        ></el-input>
        <el-select v-model="position" class="mr-10px" placeholder="位置" filterable clearable>
          <el-option
            v-for="item in positionList"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
        <el-button type="primary" @click="searchFunctionList" :disabled="!$hasAccess('read')"
          >搜索</el-button
        >
        <el-button @click="reset">重置</el-button>
        <el-button type="primary" @click="operate('create')" :disabled="!$hasAccess('create')"
          >新增</el-button
        >
        <el-button type="danger" @click="batchDetele" :disabled="!$hasAccess('delete')"
          >删除</el-button
        >
      </div>
      <!-- 列表 -->
      <div class="mx-10px h-[calc(100%-105px)]">
        <el-table
          :data="tableData"
          v-loading="functionLoading"
          row-key="id"
          border
          height="100%"
          stripe
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="50" sortable></el-table-column>
          <el-table-column prop="seqNo" label="序号" width="70"></el-table-column>
          <el-table-column
            prop="code"
            label="功能编码"
            show-overflow-tooltip
            sortable
          ></el-table-column>
          <el-table-column
            prop="name"
            label="功能名称"
            show-overflow-tooltip
            sortable
          ></el-table-column>
          <el-table-column label="功能分类" show-overflow-tooltip sortable>
            <template slot-scope="{ row }">{{ row.extraDto.functionTypeDesc }}</template>
          </el-table-column>
          <el-table-column label="数据展示位置" show-overflow-tooltip sortable>
            <template slot-scope="{ row }">{{ row.extraDto.functionLocationTypeDesc }}</template>
          </el-table-column>
          <el-table-column label="图标" show-overflow-tooltip sortable>
            <template slot-scope="{ row }">
              <i
                :class="[fontFamily, cssPrefixText + row.icon]"
                class="text-30px"
                v-if="row.functionType === 1"
              ></i>
              <img :src="getSrc(row.icon)" alt v-else class="h-40px w-40px" />
            </template>
          </el-table-column>
          <el-table-column label="标签" prop="lableDtos" show-overflow-tooltip sortable>
            <template slot-scope="{ row }">
              <i>{{ row.extraDto.lableNames }}</i>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200px">
            <template slot-scope="{ row }">
              <el-button @click="operate('read', row)" size="mini" :disabled="!$hasAccess('read')"
                >查看</el-button
              >
              <el-button
                @click="operate('update', row)"
                size="mini"
                :disabled="!$hasAccess('update')"
                >编辑</el-button
              >
              <el-button @click="deleteFunction(row)" size="mini" :disabled="!$hasAccess('delete')"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="mt-20px flex justify-end">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="getFunctionList"
          :current-page.sync="page.pageNo"
          :page-sizes="pageSizeAll"
          :page-size.sync="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
        ></el-pagination>
      </div>
    </el-card>
    <AddFunction
      v-if="createVisible"
      :visible.sync="createVisible"
      :operateProps="operateProps"
      :operateType="operateType"
      :positionList="positionList"
      :iconfontJSON="iconfontJSON"
      :fontFamily="fontFamily"
      :cssPrefixText="cssPrefixText"
      @refresh="getFunctionList"
    ></AddFunction>
  </div>
</template>

<script>
import { FunctionInfoApi } from '@wiz-api/cloud-render-management'
import iconfontJSON from '../../../../public/lib/iconfont/iconfont.json'

const functionApi = new FunctionInfoApi()
const AddFunction = () => {
  return import('../components/FunctionManagement/AddFunction')
}
export default {
  components: {
    AddFunction,
  },
  data() {
    return {
      functionName: '',
      position: '',
      status: '',
      positionList: [
        {
          value: 0,
          label: '默认',
        },
        {
          value: 1,
          label: '左侧',
        },
        {
          value: 2,
          label: '右侧',
        },
        {
          value: 3,
          label: '全屏',
        },
      ],
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      functionLoading: false,
      selectIds: [],
      pageSizeAll: [15, 30, 45, 60, 75, 90],
      createVisible: false,
      operateType: 'create',
      operateProps: {},
      iconfontJSON: '',
      fontFamily: '',
      cssPrefixText: '',
    }
  },
  async created() {
    this.functionLoading = true
    await this.getFunctionList()
    this.iconfontJSON = iconfontJSON
    this.fontFamily = iconfontJSON.font_family
    this.cssPrefixText = iconfontJSON.css_prefix_text
    this.functionLoading = false
  },
  methods: {
    // 获取板块列表
    async getFunctionList() {
      const [err, res] = await functionApi.getList({
        name: this.functionName,
        functionLocationType: this.position,
        maxResultCount: this.page.pageSize,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
      })
      if (!err && res) {
        this.tableData = res.items
        this.page.total = res.totalCount
      }
    },
    // 重置表单数据
    reset() {
      this.functionName = ''
      this.position = ''
      this.status = ''
      this.searchFunctionList();
      
    },
    // 操作
    operate(type, row) {
      this.operateType = type
      this.createVisible = true
      switch (type) {
        case 'create':
          this.operateProps = {}
          break
        case 'update':
          this.operateProps = row
          break
        case 'read':
          this.operateProps = row
          break
        default:
          break
      }
    },
    // 搜索
    searchFunctionList() {
      this.page.pageNo = 1
      this.getFunctionList()
    },
    // 批量删除
    async batchDetele() {
      if (!this.selectIds.length) {
        return this.$message({
          showClose: true,
          message: '请勾选要删除的功能',
          type: 'warning',
        })
      }
      this.$confirm('删除后将无法恢复, 确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const [err, res] = await functionApi.deleteMany({
          ids: this.selectIds,
        })
        if (!err) {
          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success',
          })
          this.getFunctionList()
        }
      })
    },
    // 获取图片地址
    getSrc(name) {
      let res = ''
      if (!_.isEmpty(name)) {
        try {
          res = require(`../../visualization-cockpit/assets/images/tab/${name}_uncheck.png`)
        } catch (error) {
          return ''
        }
      }
      return res
    },
    // 删除
    deleteFunction(row) {
      this.$confirm('删除后将无法恢复, 确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const [err, res] = await functionApi.callDelete(row.id)
        if (!err) {
          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success',
          })
          this.getFunctionList()
        }
      })
    },
    handleSizeChange(val) {
      this.page.pageNo = 1
      this.getFunctionList()
    },
    handleSelectionChange(val) {
      this.selectIds = _.map(val, (item) => {
        return item.id
      })
    },
  },
}
</script>

<style lang="scss" scoped>
#function-management {
  .head {
    ::v-deep .el-input {
      width: 200px;
    }
  }
  ::v-deep .el-card__body {
    height: 100%;
  }
}
</style>
